import { InvoiceModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/invoice.model';
import { DisplayColumnDef } from '@tanstack/react-table';

import { InvoiceListActionsCell } from './invoice-list-actions.cell';
import { InvoiceListActionsHeader } from './invoice-list-actions.header';

export const InvoiceListActionsColumn: DisplayColumnDef<InvoiceModel, unknown> =
  {
    id: 'actions',
    enableSorting: false,
    enableHiding: false,
    header: InvoiceListActionsHeader,
    cell: InvoiceListActionsCell,
  };
